import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import CheckIcon from 'svg/check.svg';
import XIcon from 'svg/x.svg';
import * as selectors from '../../../selectors';
import styles from './Merging.pcss';
const Indicator = ()=>{
    const isInProgress = useSelector(selectors.isMergePatientInProgress);
    const hasErrors = useSelector(selectors.hasMergePatientErrors);
    if (isInProgress) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.loaderContainer,
            children: /*#__PURE__*/ _jsx("img", {
                src: "/assets/svg/loader.svg",
                className: `${styles.loader} rotatingLoader`,
                alt: ""
            })
        });
    }
    const Icon = hasErrors ? XIcon : CheckIcon;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.indicatorBackground, {
            [styles.error]: hasErrors
        }),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.indicator,
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.loaderContainer,
                children: /*#__PURE__*/ _jsx(Icon, {
                    className: styles.indicatorIcon
                })
            })
        })
    });
};
export default Indicator;
